import * as React from "react";
import { Tag, Icon } from "antd";
//import Dropdown from "rc-dropdown";
import Trigger from "rc-trigger";
import 'widget/multiTag/rc-trigger.less'
// import domAlign from "dom-align";
import SelectPanel from "./selectPanel";

interface IMultiData {
  id: number;
  name: string;
}

interface IContentPanel {
  // 返回面板的显示/隐藏的状态
  retrunVisible: any;
  returnCheckedOpiton: any;
  data: Array<IMultiData>;
  // 最多显示的tag数
  tagSize?: number;
  // 下拉面板一行显示的项的数量
  optionSize?: number;
  // 占位显示的字符
  placehorder?: string;
  value?: string;
  // 获取ref
  onRef?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
}

// 内容面板
class ContentPanel extends React.Component<IContentPanel, any> {
  selectPanelVisible = false;

  constructor(props: IContentPanel) {
    super(props);

    this.props.onRef && this.props.onRef(this);

    this.state = {
      visible: false,
      // 已选中的数据
      checkedList: [],
      // 下拉面板的引用
      selectComponent: null,
      contentPanelRef: null
    };
  }

  // 控制下拉面板的位置
  align(open = false) {
    if (
      this.state.selectComponent &&
      this.state.selectComponent.state.ref &&
      this.state.contentPanelRef
    ) {
      // const ret = domAlign(
      //   this.state.selectComponent.state.ref,
      //   this.state.contentPanelRef,
      //   {
      //     points: ["tl", "tl"],

      //     targetOffset: [0, -this.state.contentPanelRef.offsetHeight - 4]
      //   }
      // );
      // console.log(ret);
    }
  }

  // 清空标签
  clear = () => {
    this.setState(
      {
        checkedList: []
      },
      () => {
        this.align();
      }
    );

    this.props.returnCheckedOpiton([]);

    // 清除下拉列中的状态
    this.state.selectComponent && this.state.selectComponent.clear();
  };

  // onVisibleChange = visible => {
  //   this.setState({
  //     visible
  //   });
  //   this.props.retrunVisible(visible);
  // };

  // 更新选中的项
  updateCheckedOpiton = data => {
    // this.setState(
    //   {
    //     checkedList: data
    //   },
    //   () => {
    //     this.align();
    //   }
    // );

    this.props.returnCheckedOpiton(data);
  };

  // 获取下拉panel的引用
  getSelectPanelRef = selectComponent => {
    this.setState(
      {
        selectComponent
      },
      () => {
        this.align(false);
      }
    );
  };

  // 删除tag
  closeTag = id => {
    const selectComponent = this.state.selectComponent;
    if (selectComponent) {
      selectComponent.unChecked(id);
    }
  };

  setVisible = () => {
    this.setState({
      visible: true
    });
    this.selectPanelVisible = true;
  };

  onPopupVisibleChange = e => {
    if (this.selectPanelVisible) {
      this.selectPanelVisible = false;
    } else {
      this.setState(
        {
          visible: e
        },
        () => {
          this.align(true);
        }
      );
      this.props.retrunVisible(e);
    }
  };

  tagClick = e => {
    this.setVisible();
  };

  // 呈现tag
  showTags = () => {
    let tags = Array<any>();
    let checkedList: any; //this.state.checkedList;

    const value: any = this.props.value;
    // let data: any; // (this.props.value && this.props.value.split(",")) || [];

    if (value) {
      if (typeof value === "string") {
        checkedList = value.split(",");
      } else if (value instanceof Array) {
        checkedList = value;
      }

      // this.setState(
      //   {
      //     checkedList: checkedList
      //   },
      //   () => {
      //     //   this.align();
      //   }
      // );

      //  this.props.returnCheckedOpiton(checkedList);
    }

    if (this.props.data && checkedList) {
      this.props.data.forEach(item => {
        const closeTag = e => {
          this.closeTag(item.id);
          this.setVisible();
        };

        // //  比对项
        // const findItem = element => {
        //   //debugger;
        //   return element === Number(item.id);
        // };

        //if (checkedList.indexOf(item.id) != -1) {
        if (
          checkedList.some(element => {
            return Number(element) === Number(item.id);
          })
        ) {
          tags.push(
            <Tag
              key={item.id}
              closable
              onClick={this.tagClick}
              onClose={closeTag}
            >
              {item.name}
            </Tag>
          );
          return true;
        } else {
          return false;
        }
      });
    }

    if (tags.length > 0) {
      return tags;
      const tagSize = this.props.tagSize || 3;
      if (tagSize >= tags.length) return tags;
      else {
        // 删除多余的tag
        tags.splice(tagSize);
        return tags;
      }
    } else
      return (
        <div className="content-panel-empty">
          {this.props.placehorder || "请选择数据"}
        </div>
      );
  };

  componentDidUpdate(prevProps) {
    this.align();
  }

  setDocument = () => {
    return document.querySelector(".content-panel");
  };

  // 设置下拉框的ref对象
  getContentPanelRef = ref => {
    this.setState({
      contentPanelRef: ref
    });
  };

  // 下拉面板位置的默认配置
  defaultAlginConfig = {
    points: ["tl", "tl"],
    targetOffset: [0, -30 - 4]
  };

  getContainer = () => {
    const containerBody = this.props.containerBody;
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };

  render() {
    const sp = (
      <SelectPanel
        data={this.props.data}
        size={this.props.optionSize || 4}
        onRef={this.getSelectPanelRef}
        value={this.props.value}
        returnCheckedOpiton={this.updateCheckedOpiton}
      />
    );

    return (
      <Trigger
        action={["click"]}
        popup={sp}
        popupAlign={this.defaultAlginConfig}
        popupVisible={this.state.visible}
        // popupVisible={false}
        getPopupContainer={this.getContainer}
        onPopupVisibleChange={this.onPopupVisibleChange}
      >
        <div className="content-panel" ref={this.getContentPanelRef}>
          {this.showTags()}
          <a className="panel-arrow">
            <Icon type="down" className="icon-animation" />
            {/* <i className="action-user action-xia" /> */}
          </a>
        </div>
      </Trigger>
    );
  }
}
export default ContentPanel;
